import chroma from "chroma-js";
import twColors from "tailwindcss/colors";

import { cyrb53 } from "./cyrb53";

import type { Color, ColorCategory, ColorIntensity } from "@corca/data";

export const tailwindColors = [
  "slate",
  "gray",
  "zinc",
  "neutral",
  "stone",
  "red",
  "orange",
  "amber",
  "yellow",
  "lime",
  "green",
  "emerald",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "violet",
  "purple",
  "fuchsia",
  "pink",
  "rose",
] satisfies (keyof typeof twColors)[];

export type TailwindColor = (typeof tailwindColors)[number];

export const colors: TailwindColor[] = [
  "slate",
  "gray",
  "red",
  "orange",
  "amber",
  "yellow",
  "lime",
  "green",
  "emerald",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "violet",
  "purple",
  "fuchsia",
  "pink",
  "rose",
];

export function getRandomTailwindColor(
  name?: string,
  fallbackColor?: TailwindColor,
): TailwindColor {
  if (name) {
    const hash = cyrb53(name);
    return colors[hash % colors.length];
  }

  if (fallbackColor) {
    return fallbackColor;
  }

  const index = Math.floor(Math.random() * colors.length);
  return colors[index];
}

export function twColorToHex(color?: Color): string | undefined {
  if (!color) return undefined;
  if (color === "black") return "#000000";
  if (color === "white") return "#FFFFFF";

  const [colorName, colorIntensity] = color.split("-") as [ColorCategory, ColorIntensity];
  const colorPalette = twColors[colorName];

  if (typeof colorPalette === "object" && colorPalette !== null) {
    const rgbHex = colorPalette[colorIntensity];

    if (chroma.valid(rgbHex)) {
      return chroma(rgbHex).hex();
    }
  }

  return undefined;
}

export function twColorToRgb(color?: Color): [number, number, number] | undefined {
  const rgbHex = twColorToHex(color);

  if (rgbHex) {
    return chroma(rgbHex).rgb();
  }

  return undefined;
}
